import PageSeo from "@/components/PageSeo";
import HeroSection from "@/components/sections/HeroSection";
import NewsletterSignupSection from "@/components/sections/NewsletterSignupSection";
import { newsletterPageContent } from "@/content/pages/newsletterPage";

export default function NewsletterPage() {
  return (
    <div className="pt-16 md:pt-20">
      <PageSeo seo={newsletterPageContent.seo} />
      <HeroSection content={newsletterPageContent.hero} dataTestId="newsletter-hero" />
      <NewsletterSignupSection content={newsletterPageContent.newsletterSection} dataTestId="newsletter-signup" className="bg-muted/50" />
    </div>
  );
}
